import { render, staticRenderFns } from "./compare-table.vue?vue&type=template&id=2f6a2eae"
import script from "./compare-table.vue?vue&type=script&lang=js"
export * from "./compare-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6a2eae')) {
      api.createRecord('2f6a2eae', component.options)
    } else {
      api.reload('2f6a2eae', component.options)
    }
    module.hot.accept("./compare-table.vue?vue&type=template&id=2f6a2eae", function () {
      api.rerender('2f6a2eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/components/compare-table.vue"
export default component.exports